import Rover from '@rover/globals/Rover';
import alooma from '@rover/globals/alooma';
import aloomaWrapper from './aloomaWrapper';

export default class Alooma {
  static init() {
    if (alooma.set_config) {
      alooma.set_config({ track_pageview: false });
    }

    const d = new Date();
    aloomaWrapper.register({ timezone_offset: d.getTimezoneOffset() });

    if (Rover.alooma && Rover.alooma.json) {
      aloomaWrapper.register(Rover.alooma.json);
    }

    if (Rover.gtm && Rover.gtm.pageCategory) {
      aloomaWrapper.register({ pageCategory: Rover.gtm.pageCategory });
    } else {
      aloomaWrapper.register({ pageCategory: 'uncategorized' });
    }

    if (Object.keys(alooma).length) {
      aloomaWrapper.aloomaLoaded();
    }
  }
}

Alooma.init();



// WEBPACK FOOTER //
// ../utilities/AloomaInitializer.js